import { Flex, Spin } from 'antd';
import { useRef } from 'react';

import { useBookingEffects, useBooking } from '@pages/Booking/hooks';

import '@pages/Booking/styles/Booking.desktop.scss';

const PF = 'booking';

export const Booking = () => {
  const {
    handleChildNavigation,
    iframeUrl,
    accessToken,
    setIsLoading,
    isLoading,
    bookingOrigin,
  } = useBooking();

  const iframeRef = useRef<HTMLIFrameElement>(null);

  useBookingEffects({
    handleChildNavigation,
    iframeRef,
    bookingOrigin,
  });

  return (
    <Flex flex={1} className={`${PF}_container`}>
      {isLoading && <Spin spinning size="large" className={`${PF}_loader`} />}
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        data-jwt={accessToken}
        data-redirect={location.pathname.replace('/', '')}
        width="100%"
        height="100%"
        allow="clipboard-write"
        frameBorder="0"
        onLoad={() => setIsLoading(false)}
      />
    </Flex>
  );
};
